import { User } from '../data/user';

export function stripUsername(firstName: string, lastName?: string) {
  if (lastName != null) {
    return `${firstName[0]}${lastName[0]}`.toUpperCase();
  }

  return firstName.slice(0, 2).toUpperCase();
}

/**
 * Detects if a user is from OCU based on email patterns or name
 * Used as fallback for misconfigured B2B accounts
 */
export function isOCUEmail(user?: User): boolean {
  if (!user) return false;

  return (
    user.email?.includes('ocu@') ||
    user.firstName?.includes('OCU') ||
    user.email?.includes('@ocu.') ||
    user.email?.includes('oklahoma') ||
    user.email?.includes('christian') ||
    false
  );
}

/**
 * Detects if a user is a B2B user (either properly configured or via email fallback)
 * B2B users should not see trial banners, upgrade buttons, or trial expired modals
 */
export function isB2BUser(user?: User): boolean {
  if (!user) return false;

  // Primary detection: user has a client relationship
  if (user.client?.name) return true;

  // Fallback: email-based detection for misconfigured accounts
  return isOCUEmail(user);
}
